{
  "articles": {
    "title": "Articles",
    "description": "Browse educational articles and resources",
    "search": {
      "placeholder": "Search articles...",
      "noResults": "No articles found",
      "tryDifferent": "Try a different search term"
    },
    "empty": {
      "title": "No articles available",
      "description": "There are no articles to display at the moment"
    },
    "readMore": "Read More",
    "details": {
      "title": "Article Details",
      "description": "Read the full article",
      "back": "Back",
      "backToArticles": "Back to Articles",
      "updated": "Updated",
      "notFound": "Article not found",
      "notFoundDescription": "The article you're looking for doesn't exist or has been removed",
      "noContent": "No content available for this article"
    }
  },
  "videos": {
    "title": "Videos",
    "description": "Watch educational videos and tutorials",
    "search": {
      "placeholder": "Search videos...",
      "noResults": "No videos found",
      "tryDifferent": "Try a different search term"
    },
    "empty": {
      "title": "No videos available",
      "description": "There are no videos to display at the moment"
    },
    "watch": "Watch",
    "details": {
      "title": "Video Details",
      "description": "Watch the full video",
      "back": "Back",
      "backToVideos": "Back to Videos",
      "updated": "Updated",
      "notFound": "Video not found",
      "notFoundDescription": "The video you're looking for doesn't exist or has been removed",
      "noVideo": "No video available",
      "learningObjectives": "Learning Objectives",
      "prerequisites": "Prerequisites"
    }
  },
  "trainings": {
    "title": "Trainings",
    "description": "Access training materials and courses",
    "search": {
      "placeholder": "Search trainings...",
      "noResults": "No trainings found",
      "tryDifferent": "Try a different search term"
    },
    "empty": {
      "title": "No trainings available",
      "description": "There are no trainings to display at the moment"
    },
    "start": "Start",
    "details": {
      "title": "Training Details",
      "description": "View the full training content",
      "back": "Back",
      "backToTrainings": "Back to Trainings",
      "updated": "Updated",
      "notFound": "Training not found",
      "notFoundDescription": "The training you're looking for doesn't exist or has been removed",
      "noContent": "No content available for this training"
    }
  },
  "admin": {
    "title": "Media Management",
    "description": "Manage articles, videos, and training content",
    "overview": {
      "articles": {
        "title": "Articles",
        "description": "Manage blog articles and content",
        "counter": "{{counter}} articles",
        "manage": "Manage Articles"
      },
      "videos": {
        "title": "Videos",
        "description": "Manage educational videos",
        "counter": "{{counter}} videos",
        "manage": "Manage Videos"
      },
      "trainings": {
        "title": "Trainings",
        "description": "Manage training content",
        "counter": "{{counter}} trainings",
        "manage": "Manage Trainings"
      },
      "recentActivity": {
        "title": "Recent Activity",
        "description": "Latest content updates"
      },
      "statistics": {
        "title": "Content Statistics",
        "description": "Overview of your content library",
        "totalContent": "Total Content",
        "publishedArticles": "Published Articles",
        "draftArticles": "Draft Articles"
      }
    },
    "articles": {
      "title": "Articles",
      "description": "Create and manage blog articles",
      "addTitle": "Create New Article",
      "addDescription": "Add a new article to your content library",
      "editTitle": "Edit Article",
      "editDescription": "Update article information",
      "deleteTitle": "Delete Article",
      "deleteDescription": "Are you sure you want to delete this article? This action cannot be undone.",
      "form": {
        "title": "Title",
        "titlePlaceholder": "Enter article title",
        "description": "Description",
        "descriptionPlaceholder": "Enter article description",
        "content": "Content",
        "contentPlaceholder": "Write your article content here...",
        "image": "Featured Image",
        "imagePlaceholder": "Upload featured image",
        "isPublished": "Published",
        "isPublishedDescription": "Make this article visible to users"
      },
      "table": {
        "title": "Title",
        "description": "Description",
        "status": "Status",
        "createdAt": "Created",
        "actions": "Actions"
      },
      "status": {
        "published": "Published",
        "draft": "Draft"
      }
    },
    "videos": {
      "title": "Videos",
      "description": "Create and manage educational videos",
      "addTitle": "Create New Video",
      "addDescription": "Add a new video to your content library",
      "editTitle": "Edit Video",
      "editDescription": "Update video information",
      "deleteTitle": "Delete Video",
      "deleteDescription": "Are you sure you want to delete this video? This action cannot be undone.",
      "form": {
        "title": "Title",
        "titlePlaceholder": "Enter video title",
        "description": "Description",
        "descriptionPlaceholder": "Enter video description",
        "content": "Content",
        "contentPlaceholder": "Write your video content here...",
        "duration": "Duration",
        "durationPlaceholder": "e.g., 15:30",
        "videoUrl": "Video URL",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=...",
        "learningObjectives": "Learning Objectives",
        "learningObjectivesPlaceholder": "What will users learn from this video?",
        "prerequisites": "Prerequisites",
        "prerequisitesPlaceholder": "What should users know before watching?",
        "image": "Thumbnail Image",
        "imagePlaceholder": "Upload video thumbnail"
      },
      "table": {
        "title": "Title",
        "description": "Description",
        "duration": "Duration",
        "createdAt": "Created",
        "actions": "Actions"
      }
    },
    "trainings": {
      "title": "Trainings",
      "description": "Create and manage training content",
      "addTitle": "Create New Training",
      "addDescription": "Add a new training to your content library",
      "editTitle": "Edit Training",
      "editDescription": "Update training information",
      "deleteTitle": "Delete Training",
      "deleteDescription": "Are you sure you want to delete this training? This action cannot be undone.",
      "form": {
        "title": "Title",
        "titlePlaceholder": "Enter training title",
        "description": "Description",
        "descriptionPlaceholder": "Enter training description",
        "content": "Content",
        "contentPlaceholder": "Write your training content here...",
        "duration": "Duration",
        "durationPlaceholder": "e.g., 2 hours",
        "videoUrl": "Video URL",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=...",
        "image": "Featured Image",
        "imagePlaceholder": "Upload training image"
      },
      "table": {
        "title": "Title",
        "description": "Description",
        "duration": "Duration",
        "createdAt": "Created",
        "actions": "Actions"
      }
    },
    "common": {
      "create": "Create",
      "creating": "Creating...",
      "update": "Update",
      "updating": "Updating...",
      "delete": "Delete",
      "deleting": "Deleting...",
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit",
      "view": "View",
      "noResults": "No results found",
      "loading": "Loading...",
      "error": "An error occurred",
      "success": "Success",
      "confirmDelete": "Are you sure?",
      "search": "Search...",
      "filter": "Filter",
      "sort": "Sort",
      "actions": "Actions",
      "openMenu": "Open menu"
    }
  },
  "success": {
    "createArticleSuccess": "Article created successfully",
    "updateArticleSuccess": "Article updated successfully",
    "deleteArticleSuccess": "Article deleted successfully",
    "createVideoSuccess": "Video created successfully",
    "updateVideoSuccess": "Video updated successfully",
    "deleteVideoSuccess": "Video deleted successfully",
    "createTrainingSuccess": "Training created successfully",
    "updateTrainingSuccess": "Training updated successfully",
    "deleteTrainingSuccess": "Training deleted successfully"
  },
  "errors": {
    "createArticleFailed": "Failed to create article",
    "createTrainingFailed": "Failed to create training",
    "createVideoFailed": "Failed to create video",
    "deleteArticleFailed": "Failed to delete article",
    "deleteTrainingFailed": "Failed to delete training",
    "deleteVideoFailed": "Failed to delete video",
    "loadArticlesFailed": "Failed to load articles",
    "loadTrainingsFailed": "Failed to load trainings",
    "loadVideosFailed": "Failed to load videos",
    "updateArticleFailed": "Failed to update article",
    "updateTrainingFailed": "Failed to update training",
    "updateVideoFailed": "Failed to update video"
  }
}
